module.exports = __webpack_public_path__ + "img/9788985635943.9832a939.jpg";